import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import { useBillingAccount } from "@/modules/billing/billingAccountQuery.ts";
import { Trans } from "@lingui/react/macro";

export function BillingDiscountNotice({ billingAccountId }: { billingAccountId: number }) {
    const account = useBillingAccount(billingAccountId);
    const discount = account.account.discount_percentage;

    return discount ? (
        <NoticeBlock className="mt-3" icon="jp-percent-icon" color="success">
            <b>
                <Trans>Your selected billing account has {discount}% discount</Trans>
            </b>
            <div>
                <Trans>Showing list prices. Discount applied in the cost summary.</Trans>
            </div>
        </NoticeBlock>
    ) : null;
}
